"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconLink = exports.TEST_ID_ICON_LINK = void 0;
var theme_ui_1 = require("theme-ui");
var theme_1 = require("../../../theme");
exports.TEST_ID_ICON_LINK = "icon-link";
function IconLink(_a) {
    var onClick = _a.onClick, href = _a.href, beforeIcon = _a.beforeIcon, afterIcon = _a.afterIcon, children = _a.children, csx = _a.csx;
    var commonStyles = {
        background: theme_1.theme.colors.secondaryLight,
        color: theme_1.theme.colors.primary,
        content: "''",
        display: "inline-block",
        mask: "no-repeat center",
        maskSize: "contain",
    };
    return (theme_ui_1.jsx(theme_ui_1.Link, { "data-testid": exports.TEST_ID_ICON_LINK, onClick: onClick, href: href, sx: __assign({ color: theme_1.theme.colors.grey100, fontFamily: theme_1.theme.fonts.body, py: 2, borderBottom: "1px solid " + theme_1.theme.colors.grey900, ":last-of-type": {
                borderBottom: "none"
            }, "::before": __assign(__assign({}, commonStyles), { display: beforeIcon ? "inline-block" : "none", height: 2, maskImage: beforeIcon ? "url(" + beforeIcon + ")" : "none", ml: 1, mr: 2, width: 2 }), "::after": __assign(__assign({}, commonStyles), { display: afterIcon ? "inline-block" : "none", height: 1, maskImage: afterIcon ? "url(" + afterIcon + ")" : "none", ml: 1, mr: 1, width: 1 }) }, csx) }, children));
}
exports.IconLink = IconLink;
